import styled from 'styled-components';
import { Modal } from 'antd';

export const StyledMapModal = styled(Modal)`
  .ant-modal-content,
  .ant-modal-header {
    background-color: ${({ theme }) => theme.greyBackground};
  }

  /* Shrink the modal to the number of slides so no empty slot is left.
     antd sets the width inline, so !important is required. One slot =
     (1435px - 48px content padding) / 5 slides ≈ 277px. 5+ slides keep
     the default width from the width prop. */
  &&:has(.slick-slide:first-child:nth-last-child(1)) {
    width: min(94vw, 325px) !important;
  }

  &&:has(.slick-slide:first-child:nth-last-child(2)) {
    width: min(94vw, 603px) !important;
  }

  &&:has(.slick-slide:first-child:nth-last-child(3)) {
    width: min(94vw, 880px) !important;
  }

  &&:has(.slick-slide:first-child:nth-last-child(4)) {
    width: min(94vw, 1157px) !important;
  }
`;
